module.exports = __webpack_public_path__ + "img/tj.tj9749373.svg";